import { EMPTY_STRING } from '../constants/common'

// mermaid is heavy and most replies have no diagram, so it is loaded lazily (its
// own chunk) on first use — a dynamic import, not a top-level one like other libs.
let mermaidPromise = null

async function importMermaid() {
  const module = await import(/* webpackChunkName: "mermaid" */ 'mermaid')
  const mermaid = module.default ?? module

  // mermaid 12 defaults to the ELK layout and the neo look — keep the 11 ones.
  mermaid.initialize({
    flowchart: { htmlLabels: false },
    layout: 'dagre',
    look: 'classic',
    securityLevel: 'strict',
    startOnLoad: false,
    theme: 'default',
  })

  return mermaid
}

function loadMermaid() {
  // Drop the cache on failure so a transient chunk-load error can be retried on
  // the next render instead of failing every diagram until reload.
  mermaidPromise ??= importMermaid().catch(error => {
    mermaidPromise = null

    throw error
  })

  return mermaidPromise
}

export async function renderMermaid({ code, id }) {
  const mermaid = await loadMermaid()

  await mermaid.parse(code)

  const { svg } = await mermaid.render(id, code)

  return svg
}

// useId produces colons, invalid in the CSS selector mermaid builds internally.
export function getMermaidDiagramId(reactId) {
  return `mermaid-${reactId.replace(/:/g, EMPTY_STRING)}`
}
